import { Component, OnInit } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
@Component({
  selector: 'page-formulario38',
  templateUrl: './formulario38.component.html',
  styleUrls: ['./formulario38.component.css']
})
export class Formulario38Component implements OnInit {
  public nombreMuni = GLOBAL.nombreMuni;
  public region = GLOBAL.region;
  public propiedad;
  public propietarios;
  public permiso_notariado;
  public arquitectos;
  public porcentajes_anteproy;
  public loteo_const;
  public tipo_mod;
  public reso_mod;
  public mod_parcial;
  public caract_proy_mod;
  public planos_mod;
  public lotes_enajenar;
  public caract_proy_garantia;
  public caract_solicitud;




 

//contadores

  public sup_total= 0;
  public sup_total_subdivision = 0 ;
  public sup_total_fusion = 0 ;
  public sup_porc= 0;
  public hoja;
  

   pages = [1,2,3];

  constructor() {

  //LOTES A ENAJENAR
    if(JSON.parse(localStorage.getItem("lotes_enajenar"))){
      if (JSON.parse(localStorage.getItem("lotes_enajenar")).length > 0){
        this.lotes_enajenar = JSON.parse(localStorage.getItem("lotes_enajenar"))
      }else{ 
        localStorage.setItem("lotes_enajenar", JSON.stringify([]))
        this.lotes_enajenar = [{lotes_enajenar:'',num_lotes:'',sup_lotes_enajenar: 0,hoja_anexa:''}]
      }
    }

  }

   ngOnInit(){

   }

   ngAfterContentChecked(){
    if(this.lotes_enajenar.length > 43){
      this.hoja = "true";
    }
    this.ngAfterContentInit();
  }

  ngDoCheck(){
    this.sup_total = 0;
    for (let i = 0; i < this.lotes_enajenar.length; i++) {
  
       this.sup_total = (this.sup_total + parseInt(this.lotes_enajenar[i].sup_lotes_enajenar)); 
      
    }
  }


   ngAfterContentInit() {

    //PROPIEDAD
    if(JSON.parse(localStorage.getItem("tipo_mod"))){
      if (JSON.parse(localStorage.getItem("tipo_mod")).length > 0){ 
        this.tipo_mod = JSON.parse(localStorage.getItem("tipo_mod"));
      }else{
      localStorage.setItem("tipo_mod", JSON.stringify([]))
        this.tipo_mod = [{mod1:'',mod2:'',mod3:'', mod4:''}]
      }
    }

    //PROPIEDAD
    if(JSON.parse(localStorage.getItem("propiedad"))){
      if (JSON.parse(localStorage.getItem("propiedad")).length > 0){ 
        this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
      }else{
       localStorage.setItem("propiedad", JSON.stringify([]))
        this.propiedad = [{rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa:'', direc_complemento:'', direc_compl_num:'', loteo:'', manzana:'', plano:'', recordId:''}]
      }
    }

    //PROPIETARIOS
    if(JSON.parse(localStorage.getItem("propietarios"))){
      if (JSON.parse(localStorage.getItem("propietarios")).length > 0){
        this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
     }else{
        localStorage.setItem("propietarios", JSON.stringify([]))
        this.propietarios = [{rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''}]
     }
    }

     //PERMISO NOTARIADO
    if(JSON.parse(localStorage.getItem("permiso_notariado"))){
      if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0){
        this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
      }else{
       localStorage.setItem("permiso_notariado", JSON.stringify([]))
        this.permiso_notariado = [{acreditacion:'', fecha:null, escritura:null, notario:''}]
      }
    }

    //ARQUITECTOS
    if(JSON.parse(localStorage.getItem("arquitectos"))){
      if (JSON.parse(localStorage.getItem("arquitectos")).length > 0){
        this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"))
      }else{ 
       localStorage.setItem("arquitectos", JSON.stringify([]))
        this.arquitectos = [{rut: '', nombre:'', mail:'', apellido_mat:'', apellido_pat:'', direccion: '', direccion_complemento:'', direccion_num:'', comuna:'', fono:'', fax:'',  patente:'', recordId:''}]
      }
    }

    //LOTES A ENAJENAR
    if(JSON.parse(localStorage.getItem("lotes_enajenar"))){
      if (JSON.parse(localStorage.getItem("lotes_enajenar")).length > 0){
        this.lotes_enajenar = JSON.parse(localStorage.getItem("lotes_enajenar"))
      }else{ 
       localStorage.setItem("lotes_enajenar", JSON.stringify([]))
        this.lotes_enajenar = [{lotes_enajenar:'',num_lotes:'',sup_lotes_enajenar:'',hoja_anexa:''}]
      }
    }

    //CARACTERISTICAS PROYECTO GARANTIA
    if(JSON.parse(localStorage.getItem("caract_proy_garantia"))){
      if (JSON.parse(localStorage.getItem("caract_proy_garantia")).length > 0){
        this.caract_proy_garantia = JSON.parse(localStorage.getItem("caract_proy_garantia"))
      }else{ 
       localStorage.setItem("caract_proy_garantia", JSON.stringify([]))
        this.caract_proy_garantia = [{total_predios_apro:'',total_predios_garantia:'', cambios:'',mod_aprobada:'',resolucion:'', fecha:null }]
      }
    }

    //CARACTERISTICAS SOLICITUD
    if(JSON.parse(localStorage.getItem("caract_solicitud"))){
      if (JSON.parse(localStorage.getItem("caract_solicitud")).length > 0){
        this.caract_solicitud = JSON.parse(localStorage.getItem("caract_solicitud"))
      }else{ 
      localStorage.setItem("caract_solicitud", JSON.stringify([]))
        this.caract_solicitud = [{num_reso_perm:'',fecha_reso_perm:null, tipo_garantia:'' }]
      }
    }
    
    
    
    
  }

  captureScreen(){
    var pdf = new jspdf('p', 'mm', 'a4');

    html2canvas(document.getElementById(`page1`)).then(canvas => {
       const contentDataURL = canvas.toDataURL('image/png')
       pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });

    html2canvas(document.getElementById(`page2`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });
    html2canvas(document.getElementById(`page3`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)  
    });
    setTimeout(() =>{
      pdf.save(this.propietarios[0].rut+'.pdf')
     // pdf.save('prueba.pdf')
    },6000)
   }
}

